import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailTellentLogoComponent } from '../../components/email-tellent-logo/email-tellent-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { TellentProductsFooterComponent } from '../../components/tellent-products-footer/tellent-products-footer.component';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  standalone: true,
  styleUrls: ['../../global-styles.less', './tellent-account-invitation.component.less'],
  templateUrl: './tellent-account-invitation.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailLinkComponent,
    EmailTellentLogoComponent,
    TellentProductsFooterComponent,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class TellentAccountInvitationTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<TellentAccountInvitationTemplateData>;
}

export type TellentAccountInvitationTemplateData = {
  avatar_url: string;
  header: string;
  subheader: string;
  body_html: string;
  privacy_policy_html: string;
  footer: {
    text: string;
    label: string;
  };
  primary_cta: {
    href: string;
    label: string;
  };
};

export const TellentAccountInvitationTemplateMocks: TellentAccountInvitationTemplateData[] = [
  {
    avatar_url:
      'https://recruitee-staging.s3.eu-central-1.amazonaws.com/admins/45690/thumb_avatar_hcwhs58oldbe.jpg',
    header: 'Join your team',
    subheader: `Hi! 👋 %{inviter} invited you to join %{company_name} in Tellent.`,
    body_html: `Tellent is a talent management suite to hire, manage, and engage your employees.`,
    privacy_policy_html:
      'By clicking “Join now” you confirm that you have read Tellent’s <a href="%{url}">Privacy Policy.</a>',
    footer: {
      text: 'Need help?',
      label: 'support@tellent.com',
    },
    primary_cta: {
      href: 'https://www.tellent.com',
      label: 'Join now',
    },
  },
];
